<!-- 合并商品清单列表 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="edit(1)">添加合并清单 (F1)</el-button>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
            </div>
        </div>
        <div class="table-ctn goodsMerge-order-table">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick" v-loading="loading">
                <el-table-column show-overflow-tooltip width="250px" prop="OrderCode" label="合并清单号"> </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="StateName" label="状态"> </el-table-column>
                <el-table-column show-overflow-tooltip width="120px" prop="Creator" label="创建人"></el-table-column>
                <el-table-column width="200" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="scope.row.State == 0" title="编辑" size="mini" type="text" @click="edit(2, scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.State == 0" title="提交" size="mini" type="text" @click="submitOrder(scope.row)">提交</el-button>
                            <el-button v-if="scope.row.State == 1" title="修改" size="mini" type="text" @click="edit(3, scope.row)">修改</el-button>
                            <el-button v-if="scope.row.State == 0" title="取消" size="mini" type="text" style="color: orange" @click="cancel(scope.row)">取消</el-button>
                            <!-- <el-button v-if="scope.row.State == 1" title="撤销" size="mini" type="text" style="color: orange" @click="cancel(scope.row)">撤销</el-button> -->
                            <el-button v-if="scope.row.State == 1" style="color: red" title="确认合并" size="mini" type="text" @click="edit(4, scope.row)"
                                >确认合并</el-button
                            >
                            <el-button title="操作记录" size="mini" type="text" @click="viewRecords(scope.row)">操作记录</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="合并清单搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-inquiry-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="清单号">
                        <el-input ref="search_sup" size="small" v-model.trim="searchData.OrderCode" placeholder="合并清单号"></el-input>
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-select style="width: 100%" size="small" v-model="searchData.SId" filterable placeholder="请输入创建人">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="合并清单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="OrderId" :OrderType="9" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import ordersLifes from '@/components/common/ordersLifes';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        ordersLifes
    },
    data() {
        return {
            isStopReq: false,
            loading: false,
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' },
                { Text: '已完成', Value: '2' }
            ],
            searchData: {
                State: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            SIdList: [],
            isStartSearch: false,
            datetime: [],
            dialogSearchVisible: false,
            OrderLifesVisible: false,
            OrderId: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_sup.focus();
                });
            }
        }
    },
    activated() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getTableData();
    },
    mounted() {
        let that = this;
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //F1
            if (key === 112) {
                e.preventDefault();
                that.edit(1);
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                if (that.SIdList.length <= 1) that.getSIdList();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
            }
            //回车
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                }
            }
            //ESC
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        edit(type, item) {
            let id = item ? item.Id : '';
            this.$router.push(`/inventoryManage/goods/goodsMergeEdit?type=${type}&id=${id}`);
        },
        resetSearch() {
            this.searchData = {
                State: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime = [];
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetGoodsMergeOrdersList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.edit(0, event);
            }
        },
        submitOrder(item) {
            let that = this;
            that.$confirm('您确定要提交清单【' + item.OrderCode + '】吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpGoods/SubmitGoodsMergeOrder?Id=` + item.Id
                        })
                        .then(res => {
                            that.$util.successMsg('提交成功');
                            item.State = 1;
                        })
                        .finally(() => {});
                })
                .catch(() => {});
        },
        cancel(item) {
            let that = this;
            that.$confirm('您确定要取消清单【' + item.OrderCode + '】吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpGoods/CancelGoodsMergeOrder?Id=` + item.Id
                        })
                        .then(res => {
                            that.$util.successMsg('取消成功');
                            that.getTableData();
                        })
                        .finally(() => {});
                })
                .catch(() => {});
        },
        showSearchDialog() {
            if (this.SIdList.length <= 1) this.getSIdList();
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getSIdList() {
            this.$util.getAuthSIdList().then(data => {
                this.SIdList = data;
            });
        },
        viewRecords(item) {
            this.OrderId = item.Id;
            this.OrderLifesVisible = true;
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
#search-inquiry-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.goodsMerge-order-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
